import { useState, useEffect, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import Alert from "../Alert";
import { alertContext } from "../contexts/AlertProvider";
import moment from "moment-timezone";
import Pagination from "../layout/Pagination";

const AllEmployees = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState("");
  const [employee, setEmployee] = useState({});
  const [popup, setPopup] = useState("");
  const [error, setError] = useState({});
  const [branches, setBranches] = useState([]);
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const token = localStorage.getItem("token");
  const limit = process.env.REACT_APP_PAGINATION_LIMIT;

  const fetchBranches = () => {
    axios
      .get(
        process.env.REACT_APP_API_ENDPOINT + `all-branches?merchantId=${null}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          setBranches(res.data.data);
        }
      })
      .catch(console.error);
  };
  const fetchEmployees = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}all-employees?page=${page}&limit=${limit}&search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 1) {
          if (page > 1) {
            if (res.data.data.length === 0) {
              setPage(page - 1);
            } else {
              setData(res.data.data);
              setCount(res.data.count);
              setIsLoading(false);
            }
          } else {
            setData(res.data.data);
            setCount(res.data.count);
            setIsLoading(false);
          }
        }
      })
      .catch(console.error);
  };
  const openPopup = (action, data) => {
    switch (action) {
      case "edit-employee":
        setEmployee(data);
        break;
      case "reset-password-employee":
        setEmployee(data);
        break;
      case "delete-employee":
        setEmployee(data);
        break;
      default:
        break;
    }
    setPopup(action);
  };
  const editEmployee = () => {
    const errors = {};
    if (employee.name === undefined || employee.name === "") {
      errors["name"] = "Please Enter Name";
    }
    if (employee.email === undefined || employee.email === "") {
      errors["email"] = "Please Enter Email";
    }
    if (employee.role === undefined || employee.role === "") {
      errors["role"] = "Please Select Role";
    }
    if (employee.branchId === undefined || employee.branchId === "") {
      errors["branchId"] = "Please Select Branch";
    }

    setError({ ...errors });
    if (
      errors.name === undefined &&
      errors.email === undefined &&
      errors.role === undefined &&
      errors.branchId === undefined
    ) {
      axios
        .post(process.env.REACT_APP_API_ENDPOINT + "edit-employee", employee, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res) {
            if (res.data.code === 0) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "danger",
              });
            }
            if (res.data.code === 1) {
              setPopup("");
              setEmployee({});
              setError({});
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
              fetchEmployees();
            }
          }
        })
        .catch(console.error);
    }
  };
  const deleteEmployee = () => {
    axios
      .post(process.env.REACT_APP_API_ENDPOINT + "delete-employee", employee, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res) {
          if (res.data.code === 0) {
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "danger",
            });
          }
          if (res.data.code === 1) {
            setPopup("");
            setEmployee({});
            setError({});
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "success",
            });
            fetchEmployees();
          }
        }
      })
      .catch(console.error);
  };
  const resetPasswordEmployee = () => {
    axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + "reset-password-employee",
        employee,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res) {
          if (res.data.code === 0) {
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "danger",
            });
          }
          if (res.data.code === 1) {
            setPopup("");
            setEmployee({});
            setError({});
            setAlertConfig({
              show: true,
              message: res.data.message,
              type: "success",
            });
            fetchEmployees();
          }
        }
      })
      .catch(console.error);
  };
  useEffect(() => {
    fetchEmployees();
  }, [page, search]);
  useEffect(() => {
    fetchBranches();
  }, []);
  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Employees List
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}

            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                <div className="card">
                  {/*begin::Card header*/}
                  <div className="card-header border-0 pt-6">
                    {/*begin::Search*/}
                    <div className="w-100 my-1">
                      <input
                        type="text"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                        className="form-control w-100"
                        placeholder="Search Employees"
                      />
                    </div>
                    {/*end::Search*/}
                  </div>
                  {/*end::Card header*/}

                  {/*begin::Card body*/}
                  <div className="card-body py-4 text-center">
                    {/*begin::Table*/}
                    {data?.length === 0 ? (
                      <div className="text-center w-100">
                        <img
                          className="w-25 mx-auto py-20"
                          src={`${process.env.REACT_APP_PUBLIC_URL}assets/media/misc/no-content.png`}
                          alt="no-content"
                        />
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table
                          className="table align-middle table-row-dashed fs-6 gy-5"
                          id=""
                        >
                          <thead>
                            <tr className="text-muted fw-bold fs-7 text-uppercase gs-0">
                              <th className="text-center min-w-120px">
                                Employee Name
                              </th>
                              <th className="text-center min-w-120px">
                                Employee Email
                              </th>
                              <th className="text-center min-w-120px">
                                Employee Role
                              </th>
                              <th className="text-center min-w-120px">
                                Employee Branch
                              </th>
                              <th className="text-center min-w-120px">
                                Memeber Since
                              </th>
                              <th className="text-center min-w-120px">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody
                            className="text-gray-600 fw-semibold"
                            id="filterDataWrap"
                          >
                            {data &&
                              data.map((employee, index) => {
                                return (
                                  <tr key={index} className="text-center">
                                    <td>
                                      {/*begin::User details*/}
                                      <div className="">
                                        <a
                                          href="#"
                                          className="text-gray-800 text-hover-primary"
                                        >
                                          {employee?.name}
                                        </a>
                                      </div>
                                      {/*begin::User details*/}
                                    </td>
                                    <td>{employee?.email}</td>
                                    <td>
                                      <div className="badge badge-light fw-bold">
                                        {employee?.role}
                                      </div>
                                    </td>
                                    <td>{employee?.branchName}</td>
                                    <td>
                                      {moment(employee?.createdAt)
                                        .tz(process.env.REACT_APP_TIMEZONE)
                                        .format("Do MMM, YYYY")}
                                    </td>
                                    <td className="">
                                      <div className="btn-group">
                                        {/*begin::Edit*/}
                                        <button
                                          onClick={() => {
                                            openPopup(
                                              "edit-employee",
                                              employee
                                            );
                                          }}
                                          className="btn px-2 btn-outline btn-primary btn-color-white btn-sm"
                                          title="Edit Employee"
                                        >
                                          <i className="bi-duotone bi-pen fs-5"></i>
                                        </button>
                                        {/*end::Edit*/}
                                        {/*begin::Reset Password*/}
                                        <button
                                          onClick={() => {
                                            openPopup(
                                              "reset-password-employee",
                                              employee
                                            );
                                          }}
                                          className="btn px-2 btn-outline btn-warning btn-color-white btn-sm"
                                          data-bs-toggle="tooltip"
                                          data-bs-placement="top"
                                          title="Reset Password"
                                        >
                                          <i className="bi-duotone bi-key fs-5"></i>
                                        </button>
                                        {/*end::Reset Password*/}
                                        {/*begin::Delete*/}
                                        <button
                                          onClick={() => {
                                            openPopup(
                                              "delete-employee",
                                              employee
                                            );
                                          }}
                                          className="btn px-2 btn-outline btn-danger btn-color-white btn-sm"
                                          title="Delete Employee"
                                        >
                                          <i className="bi-duotone bi-trash fs-5"></i>
                                        </button>
                                        {/*end::Delete*/}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {/*end::Table*/}
                    {/*begin::Paginate*/}
                    {count && Math.ceil(count / limit) > 1 ? (
                      <Pagination
                        page={page}
                        setPage={setPage}
                        count={count}
                        limit={limit}
                      />
                    ) : (
                      ""
                    )}
                    {/*begin::Paginate*/}
                  </div>
                  {/*end::Card body*/}
                </div>
                {/*end::Card*/}
              </div>
              {/*end::Post*/}
            </div>
          </div>
          {/*begin::Modal - Edit Employee*/}
          {popup && popup === "edit-employee" ? (
            <div
              className="modal fade show d-block"
              id="editEmployeeModal"
              tabindex="-1"
              aria-hidden="true"
            >
              {/*begin::Modal dialog*/}
              <div className="modal-dialog modal-dialog-centered modal-lg">
                {/*begin::Modal content*/}
                <div className="modal-content rounded">
                  {/*begin::Modal header*/}
                  <div className="modal-header">
                    {/*begin::Close*/}
                    <h4>Edit Employee</h4>
                    {/*end::Close*/}
                  </div>
                  {/*end::Modal header*/}

                  {/*begin::Modal body*/}
                  <div className="modal-body p-4">
                    <div className="row">
                      <div className="col">
                        <label className="form-label required">Name</label>
                        <input
                          value={employee?.name ?? ""}
                          onChange={(e) => {
                            setEmployee({
                              ...employee,
                              name: e.target.value,
                            });
                            setError({ ...error, name: "" });
                          }}
                          id="employee_name"
                          className="form-control"
                          placeholder="Employee Name"
                          autoComplete="off"
                        />
                        {error.name !== undefined && error.name !== "" ? (
                          <small className="text-danger mt-2">
                            {error.name}
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col">
                        <label className="form-label required">Email</label>
                        <input
                          value={employee?.email ?? ""}
                          onChange={(e) => {
                            setEmployee({
                              ...employee,
                              email: e.target.value,
                            });
                            setError({ ...error, email: "" });
                          }}
                          id="employee_email"
                          className="form-control"
                          placeholder="Employee Email"
                          autocomplete="off"
                        />
                        {error.email !== undefined && error.email !== "" ? (
                          <small className="text-danger mt-2">
                            {error.email}
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="row mt-3">
                      <div className="col">
                        <label className="form-label required">Role</label>
                        {/*begin::Input group*/}
                        <div className="row mb-0 text-start">
                          {/*begin::Input group*/}
                          <div className="mb-5">
                            <Select
                              className="react-select-styled react-select-bordered"
                              classNamePrefix="react-select"
                              defaultValue={
                                employee?.role
                                  ? {
                                      value: employee.role,
                                      label: employee.role,
                                    }
                                  : null
                              }
                              onChange={(e) => {
                                setEmployee({
                                  ...employee,
                                  role: e.value,
                                });
                                setError({ ...error, role: "" });
                              }}
                              options={[
                                {
                                  value: "Employee",
                                  label: "Employee",
                                },
                                {
                                  value: "Owner",
                                  label: "Owner",
                                },
                                {
                                  value: "Manager",
                                  label: "Manager",
                                },
                                {
                                  value: "Accountant",
                                  label: "Accountant",
                                },
                              ]}
                              placeholder="Select an option"
                            />
                          </div>
                          {/*end::Input group*/}
                        </div>
                        {/*end::Input group*/}
                        {error.role !== undefined && error.role !== "" ? (
                          <small className="text-danger mt-2">
                            {error.role}
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="col">
                        <label className="form-label required">Branch</label>
                        {/*begin::Input group*/}
                        <div className="row mb-0 text-start">
                          {/*begin::Input group*/}
                          <div className="mb-5">
                            <Select
                              className="react-select-styled react-select-bordered"
                              classNamePrefix="react-select"
                              onChange={(e) => {
                                setEmployee({
                                  ...employee,
                                  branchId: e.value,
                                });
                                setError({ ...error, branchId: "" });
                              }}
                              options={branches?.map((item) => {
                                return {
                                  value: item._id,
                                  label: item.name,
                                };
                              })}
                              defaultValue={
                                employee?.branchId
                                  ? {
                                      value: employee.branchId,
                                      label: employee.branchName,
                                    }
                                  : null
                              }
                              placeholder="Select an option"
                            />
                          </div>
                          {/*end::Input group*/}
                        </div>
                        {/*end::Input group*/}
                        {error.branchId !== undefined &&
                        error.branchId !== "" ? (
                          <small className="text-danger mt-2">
                            {error.branchId}
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    {/*begin::Actions*/}
                    <div className="d-flex flex-row-fluid pt-12">
                      <button
                        type="button"
                        className="btn btn-sm btn-secondary me-3"
                        onClick={() => {
                          setPopup("");
                        }}
                      >
                        Close
                      </button>

                      <button
                        onClick={editEmployee}
                        type="button"
                        className="btn btn-primary btn-sm"
                      >
                        Update
                      </button>
                    </div>
                    {/*end::Actions*/}
                  </div>
                  {/*end::Modal body*/}
                </div>
                {/*end::Modal content*/}
              </div>
              {/*end::Modal dialog*/}
            </div>
          ) : (
            ""
          )}
          {/*end::Modal - Edit Employee*/}
          {/*begin::Modal - Delete Employee*/}
          {popup && popup === "delete-employee" ? (
            <div
              className="modal fade show d-block"
              id="deleteEmployeeModal"
              tabindex="-1"
              aria-hidden="true"
            >
              {/*begin::Modal dialog*/}
              <div className="modal-dialog modal-dialog-centered modal-sm">
                {/*begin::Modal content*/}
                <div className="modal-content text-center bg-danger text-light">
                  {/*begin::Modal header*/}
                  <div className="modal-header">
                    {/*begin::Close*/}
                    <h5 className="modal-title mx-auto text-light">
                      DELETE EMPLOYEE
                    </h5>
                    {/*end::Close*/}
                  </div>
                  {/*end::Modal header*/}

                  {/*begin::Modal body*/}
                  <div className="modal-body p-4">
                    <h4 className="text-center my-5 text-light">
                      Are You Sure ?
                    </h4>
                  </div>
                  {/*end::Modal body*/}
                  {/*begin::Actions*/}
                  <div className="modal-footer justify-content-center">
                    <button
                      type="button"
                      className="btn btn-sm btn-light me-3"
                      onClick={() => {
                        setEmployee({});
                        setError({});
                        setPopup("");
                      }}
                    >
                      Close
                    </button>

                    <button
                      onClick={deleteEmployee}
                      type="button"
                      className="btn btn-light btn-sm"
                      id="kt_modal_upgrade_plan_btn"
                    >
                      {/*begin::Indicator label*/}
                      <span className="indicator-label">Delete</span>
                      {/*end::Indicator label*/}
                      {/*end::Indicator progress*/}
                    </button>
                  </div>
                  {/*end::Actions*/}
                </div>
                {/*end::Modal content*/}
              </div>
              {/*end::Modal dialog*/}
            </div>
          ) : (
            ""
          )}
          {/*end::Modal - Delete Employee*/}
          {/*begin::Modal - Reset Employee Password */}
          {popup && popup === "reset-password-employee" ? (
            <div
              className="modal fade show d-block"
              id="resetEmployeePasswordModal"
              tabindex="-1"
              aria-hidden="true"
            >
              {/*begin::Modal dialog*/}
              <div className="modal-dialog modal-dialog-centered modal-sm">
                {/*begin::Modal content*/}
                <div className="modal-content text-center bg-warning text-light">
                  {/*begin::Modal header*/}
                  <div className="modal-header">
                    {/*begin::Close*/}
                    <h5 className="modal-title mx-auto text-light">
                      RESET PASSWORD
                    </h5>
                    {/*end::Close*/}
                  </div>
                  {/*end::Modal header*/}

                  {/*begin::Modal body*/}
                  <div className="modal-body p-4">
                    <h4 className="text-center my-5 text-light">
                      Are You Sure ?
                    </h4>
                  </div>
                  {/*end::Modal body*/}
                  {/*begin::Actions*/}
                  <div className="modal-footer justify-content-center">
                    <button
                      type="button"
                      className="btn btn-sm btn-light me-3"
                      onClick={() => {
                        setEmployee({});
                        setError({});
                        setPopup("");
                      }}
                    >
                      Close
                    </button>

                    <button
                      onClick={resetPasswordEmployee}
                      type="button"
                      className="btn btn-light btn-sm"
                      id="kt_modal_upgrade_plan_btn"
                    >
                      {/*begin::Indicator label*/}
                      <span className="indicator-label">Reset Password</span>
                      {/*end::Indicator label*/}
                      {/*end::Indicator progress*/}
                    </button>
                  </div>
                  {/*end::Actions*/}
                </div>
                {/*end::Modal content*/}
              </div>
              {/*end::Modal dialog*/}
            </div>
          ) : (
            ""
          )}

          {/*end::Modal - Reset Employee Password*/}
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default AllEmployees;
